import Vue from 'vue';
const EventBus = new Vue();

// const plugin = {
//     install: function (Vue) {

//         Vue.prototype.$eventBus = EventBus
//         Vue.$eventBus = EventBus
//     }
// }

export default EventBus